'use client';
import Image from 'next/image';

interface PlansFeatureProps {
  index: number;
  selectedPlan: string;
  feature: string;
  availablePlans: any[];
  plans: {
    id: string;
  }[];
}
export function PlansFeature(props: PlansFeatureProps) {
  const { index, selectedPlan, plans, feature, availablePlans } = props;

  const crossPlans = availablePlans.map((plan) => {
    return {
      id: plan.id,
      name: plan.name,
      featureHasPlan: plans.some((p) => p.id === plan.id)
    };
  });

  const mobileCrossPlans = availablePlans
    .map((plan) => {
      return {
        id: plan.id,
        name: plan.name,
        featureHasPlan: plans.some((p) => p.id === plan.id)
      };
    })
    .filter((plan) => plan.id === selectedPlan);

  return (
    <>
      <div
        className={`hidden flex-row items-center justify-between gap-[16px] px-3 py-4 lg:flex ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}
      >
        <div className="flex flex-1">
          <h3 className="text-[16px] font-normal">{feature}</h3>
        </div>

        {crossPlans.map((plan, index) => (
          <div
            key={index}
            className={`flex w-[270px] flex-col items-center justify-center gap-[10px] rounded-lg px-6`}
          >
            {plan.featureHasPlan ? (
              <div className="circle-check rounded-full bg-green-500 p-2">
                <Image src="/icons/check.svg" alt="check" width={10} height={10} />
              </div>
            ) : (
              <Image src="/icons/cross.svg" alt="cross" width={16} height={16} />
            )}
          </div>
        ))}
      </div>

      <div
        className={`flex flex-row items-center justify-between gap-[16px] px-3 py-4 lg:hidden ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}
      >
        <div className="flex flex-1">
          <h3 className="text-[16px] font-normal">{feature}</h3>
        </div>

        {!!selectedPlan &&
          mobileCrossPlans.map((plan, index) => (
            <div
              key={index}
              className={`flex flex-col items-center justify-center gap-[10px] rounded-lg px-6`}
            >
              {plan.featureHasPlan ? (
                <div className="circle-check rounded-full bg-green-500 p-2">
                  <Image src="/icons/check.svg" alt="check" width={10} height={10} />
                </div>
              ) : (
                <Image src="/icons/cross.svg" alt="cross" width={16} height={16} />
              )}
            </div>
          ))}
      </div>
    </>
  );
}
